import allowedCountriesEN from '@cakedefi/cake-sdk/assets/allowed-countries-en.json';

export function getCountryWithCode(code: string) {
  if (code === 'UR') { // Myinfo return nationality code UR for Ukraine
    return 'Ukraine';
  }
  return allowedCountriesEN.find(item => item.value === code)?.label;
}
